import { polyfill as smoothscroll } from 'smoothscroll-polyfill';

smoothscroll();
